import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslatePipe } from '../../../pipes/translate.pipe';


@Component({
  selector: 'app-yes-no-checkbox',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule, TranslatePipe],
  template: `
    <div class="yes-no-checkbox">
      <label>{{ label | translate }}@if (required) {<span class="required-asterisk">*</span>}</label>
      <div class="checkbox-options">
        <mat-checkbox 
          [checked]="value === 'true'"
          (change)="onYesChange($event.checked)"
          color="primary">
          {{ 'common.yes' | translate }}
        </mat-checkbox>
        
        <mat-checkbox 
          [checked]="value === 'false'"
          (change)="onNoChange($event.checked)"
          color="primary">
          {{ 'common.no' | translate }}
        </mat-checkbox>
      </div>
    </div>
  `,
  styles: [`
    .yes-no-checkbox {
      margin-bottom: 16px;
    }
    
    label {
      display: block;
      font-weight: 500;
      margin-bottom: 8px;
      color: #333;
    }
    
    .required-asterisk {
      color: #f44336;
      margin-left: 4px;
    }
    
    .checkbox-options {
      display: flex;
      gap: 24px;
    }
    
    mat-checkbox {
      font-size: 14px;
    }
  `]
})
export class YesNoCheckboxComponent {
  @Input() label: string = '';
  @Input() value: string | null = null;
  @Input() required: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  onYesChange(checked: boolean): void {
    if (checked) {
      this.value = 'true';
      this.valueChange.emit('true');
    } else if (this.value === 'true') {
      this.value = null;
      this.valueChange.emit('');
    }
  }

  onNoChange(checked: boolean): void {
    if (checked) {
      this.value = 'false';
      this.valueChange.emit('false');
    } else if (this.value === 'false') {
      this.value = null;
      this.valueChange.emit('');
    }
  }
}